import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./theme/default.css"; // Import theme - change to blue.css or green.css for different clients
import App from "./App";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
